<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">Who is the Customer?</div>
    </template>

    <div class="rounded-lg pa-4" style="background-color: white;">
    <v-form ref="form" @submit.prevent="customerClick">
      <StructureTypeSelect
        outlined dense
        v-model="structure_type"
        :rules="[required]"
        validate-on-blur
      />

      <v-text-field
        outlined dense
        v-model="name"
        :rules="[required]"
        label="Customer Name"
        validate-on-blur
      />
      <v-text-field
        outlined dense
        v-model="phone"
        :rules="[required, valid_us_phone]"
        label="Phone Number"
        autocomplete="customer_phone"
        v-mask="'(###) ###-####'"
        validate-on-blur
      />
      <v-text-field
        outlined dense
        v-model="zipcode"
        :rules="[required, valid_us_zipcode]"
        label="Zipcode (to find Pros in the area)"
        autocomplete="customer_email"
      />

      <v-textarea
        outlined dense
        v-model="notes" :rows="3"
        label="Help the pro with detailed notes"
      />

      <div class="d-flex justify-center mt-n1 mb-1">
        <v-btn color="primary" type="submit">Next</v-btn>
      </div>
      </v-form>
    </div>
  </ContentPage>
</template>


<script>
  import { ContentPage } from '@/components/pages'
  import { StructureTypeSelect } from '@/components/inputs'
  import { required, valid_email, valid_us_phone, valid_us_zipcode } from '@/lib/validations'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'ReferralsCustomer',
     
    components: { ContentPage, StructureTypeSelect },

    data() {
      return {
        structure_type: '',
        name: '',
        notes: '',
        phone: '',
        zipcode: '',

        // field validations
        required, valid_email, valid_us_phone, valid_us_zipcode,
      }
    },

    computed: {
      ...mapGetters('auth', ['me']),
      ...mapGetters('referrals', ['currentRequest', 'currentService']),
    },

    methods: {
      ...mapActions('referrals', ['setCurrentRequest']),

      customerClick() {
        if (this.$refs.form.validate()) {
          const payload = { 
            name: this.name,
            notes: this.notes,
            phone: this.phone,
            structure_type: this.structure_type,
            zipcode: this.zipcode,
            service_id: this.currentService.service_id,
          }

          this.setCurrentRequest(payload)

          console.log(this.me)
          if (this.me.role == 'admin') {
            this.$router.push({ name: 'referrals/method' })
          } else {
            this.$router.push({ name: 'referrals/confirm', params: { automatic: true } })
          }
        }
      }
    },

    created() {
      if (!this.currentService) {
        this.$router.replace({ name: 'referrals' })
      } else {
        this.name = this.currentRequest.name
        this.notes = this.currentRequest.notes
        this.phone = this.currentRequest.phone
        this.structure_type = this.currentRequest.structure_type
        this.zipcode = this.currentRequest.zipcode
      }
    }
  }
</script>